<cbs-product-content>
  <cbs-cos></cbs-cos>
  <cbs-product-options></cbs-product-options>
</cbs-product-content>
